// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__Dir79","inputWrap":"styles_inputWrap__ruHvc","input":"styles_input__pN9vX"};